import { router } from 'expo-router';
import { Pressable, StyleSheet, View } from 'react-native';

import { IconChevronRight, Text, tokens } from '@fhs/ui';
import { useCRMEventsContext } from '@fhs-legacy/frontend/src/state/crm-events';
import {
  CHECKOUT_PAYMENT_DETAILS_HEADING,
  CHECKOUT_PAYMENT_METHOD_BUTTON,
} from '@fhs-legacy/frontend/src/utils/test-ids';

import { usePaymentMethodStore } from '../../../payment';
import { NewCardForm } from '../../../payment/components';
import { logPaymentMethodSelectionOpened } from '../../../utils/logging-utils';

import { getPaymentMethodDisplay } from './payment-method-icon-map';

export default function CheckoutPaymentDetails() {
  const selectedPaymentMethod = usePaymentMethodStore(state => state.selectedPaymentMethod);
  const showAddPaymentMethod = usePaymentMethodStore(state => state.showAddPaymentMethod);
  const savedCardData = usePaymentMethodStore(state => state.savedCardData);
  const { logRBIEvent } = useCRMEventsContext();

  const paymentDisplay = getPaymentMethodDisplay(selectedPaymentMethod, savedCardData);

  const handleOpenPaymentSelection = () => {
    logPaymentMethodSelectionOpened(logRBIEvent);
    router.setParams({ action: 'payment' });
  };

  return (
    <>
      <Text.Heading type="four" style={styles.heading} testID={CHECKOUT_PAYMENT_DETAILS_HEADING}>
        Payment Details
      </Text.Heading>

      <Pressable
        testID={CHECKOUT_PAYMENT_METHOD_BUTTON}
        style={styles.anchor}
        focusable
        onPress={handleOpenPaymentSelection}
        onAccessibilityTap={handleOpenPaymentSelection}
        accessibilityRole="button"
        accessibilityLabel={`Payment method: ${paymentDisplay.label}`}
        accessibilityHint="Tap to change payment method"
      >
        {props => (
          <View
            style={[styles.container, props.pressed && styles.pressedContainer]}
            accessible={false}
          >
            <View
              style={[styles.iconCircle, props.pressed && styles.iconCirclePressed]}
              accessible={false}
            >
              {paymentDisplay.icon}
            </View>
            <Text.Ui weight="semibold" size="lg" style={styles.text} accessible={false}>
              {paymentDisplay.label}
            </Text.Ui>
            <IconChevronRight size={24} accessible={false} />
          </View>
        )}
      </Pressable>

      {/* Show the form if the user chose to add a card or if there isn't a default or selected payment method  */}
      {(showAddPaymentMethod || !selectedPaymentMethod) && <NewCardForm />}
    </>
  );
}

const styles = StyleSheet.create({
  heading: {
    marginTop: 20,
    marginBottom: 12,
    marginHorizontal: 28,
  },
  pressedContainer: {
    backgroundColor: tokens.colors.$houseLight,
  },
  container: {
    alignItems: 'center',
    height: 72,
    width: '100%',
    borderColor: tokens.colors.$black10,
    backgroundColor: tokens.colors.$white,
    borderWidth: StyleSheet.hairlineWidth,
    borderRadius: 8,
    gap: 8,
    padding: 16,
    flexDirection: 'row',
  },
  text: {
    flex: 1,
  },
  anchor: {
    marginHorizontal: 28,
  },
  iconCirclePressed: {
    backgroundColor: tokens.colors.$black10,
  },
  iconCircle: {
    height: 40,
    width: 40,
    borderRadius: 40,
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: tokens.colors.$houseLight,
  },
});
